<template>
  <form @submit.prevent="submit">
    <v-row>
      <v-col cols="6">
        <DateSelector
          label="Od"
          :date="form.startDate"
          @change="updateStartDate"
        />
      </v-col>
      <v-col cols="6">
        <DateSelector
          label="Do"
          :date="form.endDate"
          @change="updateEndDate"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="form.clientName"
          label="Dobavitelj"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="form.deliveryDocument"
          label="Št. prevzemnice"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn type="submit" class="float-right">Išči</v-btn>
      </v-col>
    </v-row>
  </form>
</template>

<script>
import moment from 'moment'
import DateSelector from './DateSelector'

export default {
  components: {
    DateSelector
  },
  data () {
    return {
      form: {
        startDate: '',
        endDate: '',
        clientName: null,
        deliveryDocument: null
      }
    }
  },
  methods: {
    submit () {
      this.$emit('submit', this.form)
    },
    clearForm () {
      this.form = {
        startDate: null,
        endDate: null,
        clientName: null,
        deliveryDocument: null
      }
    },
    updateStartDate ({ date }) {
      this.form.startDate = date
    },
    updateEndDate ({ date }) {
      this.form.endDate = date
    }
  },
  created () {
    this.clearForm()
    const storeFilters = this.$store.state.acceptanceForms.filters
    if (storeFilters) {
      this.form.startDate = storeFilters.dateFrom
      this.form.endDate = storeFilters.dateTo
      this.form.clientName = storeFilters.clientName
      this.form.deliveryDocument = storeFilters.deliveryDocument
    }
    if (!this.form.startDate) this.form.startDate = moment().subtract(30, 'days').format('YYYY-MM-DD')
    if (!this.form.endDate) this.form.endDate = moment().format('YYYY-MM-DD')
    // console.log(this.form)
    this.submit()
  }
}
</script>
